import React from 'react';
import { Star, Quote, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('testimonials.t1'),
    name: 'Sarah M.',
    city: 'Austin, TX',
    avatar: 'https://i.pravatar.cc/100?img=47'
  }, {
    quote: t('testimonials.t2'),
    name: 'David L.',
    city: 'Chicago, IL',
    avatar: 'https://i.pravatar.cc/100?img=11'
  }, {
    quote: t('testimonials.t3'),
    name: 'Elena R.',
    city: 'Miami, FL',
    avatar: 'https://i.pravatar.cc/100?img=32'
  }, {
    quote: t('testimonials.t4'),
    name: 'Michael T.',
    city: 'Denver, CO',
    avatar: 'https://i.pravatar.cc/100?img=68'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-468">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-469">
        <div className="text-center mb-12" data-id="element-470">
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-471">
            {t('testimonials.title')}
          </h2>
          <p className="text-xl text-[#3E2723]/70" data-id="element-472">{t('testimonials.desc')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-473">
          {testimonials.map((tItem, idx) => <div key={idx} className="bg-[#FBF7F0] p-8 rounded-2xl shadow-lg border border-[#3E2723]/5 relative" data-id="element-474">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#C2410C]/10" data-id="element-475" />
              <div className="flex gap-1 mb-4" data-id="element-476">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-477" />)}
              </div>
              <p className="text-lg text-[#3E2723]/80 mb-6 italic relative z-10" data-id="element-478">
                "{tItem.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-479">
                <img src={tItem.avatar} alt={tItem.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#C2410C]" data-id="element-480" />
                <div data-id="element-481">
                  <div className="font-bold text-[#3E2723]" data-id="element-482">{tItem.name}</div>
                  <div className="text-sm text-[#3E2723]/60" data-id="element-483">{tItem.city}</div>
                </div>
                <div className="ml-auto flex items-center gap-1 text-xs font-semibold text-[#14B8A6] bg-[#14B8A6]/10 px-2 py-1 rounded-full" data-id="element-484">
                  <CheckCircle2 className="w-3 h-3" data-id="element-485" />
                  {t('testimonials.verified')}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}